var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.292 3.592C32.9 2.177 31.75 1.066 30.286.687 27.633 0 17 0 17 0S6.367 0 3.717.687C2.253 1.066 1.103 2.177.71 3.592 0 6.153 0 11.5 0 11.5s0 5.347.71 7.908c.393 1.415 1.543 2.526 3.007 2.905C6.367 23 17 23 17 23s10.633 0 13.283-.687c1.464-.379 2.614-1.49 3.006-2.905C34 16.847 34 11.5 34 11.5s0-5.347-.71-7.908h.002Z",
    fill: "red"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13.6 16.428 8.836-4.928L13.6 6.572v9.856Z",
    fill: "#fff"
  })));
};
export default SvgYoutube;